'use client';

import { useDispatch, useSelector } from 'react-redux';
import { updateAuction } from '../redux/auctionsSlice/auctionsSlice';
import io from 'socket.io-client';
import Echo from 'laravel-echo';
import { useEffect, useState } from 'react';
import isCustomersBid from '../utils/isCustomersBid';
import {
  clearAuctionsList,
  updateAuctionsList,
} from '../redux/auctionsSlice/customerAuctionsSlice';
import { customerState } from '../redux/customerSlice/customerSlice';
import { RootState } from '../redux/store';

declare global {
  interface Window {
    echo: any;
    io: any;
  }
}

export default function WebSocketComponent() {
  const dispatch = useDispatch();
  const [lastAuction, setLastAuction] = useState({} as any);

  const customer: customerState = useSelector((state: RootState) => {
    return state.customer;
  });

  const hasCustomerPlacedBid = (bids: any[]) => {
    if (!bids) {
      return false;
    }
    return bids.some((bid) => isCustomersBid(customer, bid));
  };

  if (hasCustomerPlacedBid(lastAuction?.bids)) {
    dispatch(updateAuctionsList(lastAuction.id));
  }

  useEffect(() => {
    dispatch(clearAuctionsList());
  }, [customer, dispatch]);

  useEffect(() => {
    if (!window.io) {
      window.io = io;
    }
    if (!window.echo) {
      window.echo = new Echo({
        broadcaster: 'socket.io',
        host: process.env.NEXT_PUBLIC_WS_URL,
        encrypted: true,
        forceTLS: false,
        logToConsole: true,
      });
    }

    window.echo.channel(`auctions-channel`).listen('.bid', (e: any) => {
      dispatch(
        updateAuction({
          ...e,
        })
      );
      setLastAuction(e);
    });

    return () => {
      window.echo.leaveChannel(`auctions-channel`);
    };
  }, [dispatch]);

  return null;
}
